export const BuiltInPropertyNames = {
  Name: 'Name',
  Description: 'Description',
} as const
